<template>
  <div>
    <a
        href="javascript:;"
        data-toggle="modal"
        data-target="#warning-modal-preview"
        style="display: none"
        id="show-modal"
        class="button inline-block bg-theme-1 text-white"
    >Show Modal</a
    >
    <div id="warning-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
          <div class="text-3xl mt-5">Oops...</div>
          <div class="text-gray-600 mt-2">Error: The email provided is already registered. Please sign in. </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
        <div
            class="p-5 text-center border-t border-gray-200 dark:border-dark-5"
        >
        </div>
      </div>
    </div>
    <div class="block xl:grid grid-cols-2 gap-4">
      <!-- BEGIN: Register Info -->
      <div class="hidden xl:flex flex-col min-h-screen" >
        <div class="my-auto">
          <img
              alt="Midone Tailwind HTML Admin Template"
              class="-intro-x w-1/2 -mt-16"
              :src="require(`@/assets/images/illustration.svg`)"
              style="margin-left: 100px;"
          />
          <div
              class="-intro-x text-gray font-medium text-4xl leading-tight mt-10" style="margin-left: 100px;"
          >
            A few more clicks to <br />
            create an account.
          </div>
          <div class="-intro-x mt-5 text-lg text-gray-700 dark:text-gray-300" style="margin-left: 100px;">
            There is no need to take hours costing you hundreds of
            dollars transcribing the results of a PMST results .pdf into a usable
            and editable format.
            Sign up and get started now.<br> Your details will not be shared or provided to third parties.
          </div>
        </div>
      </div>
      <!-- END: Register Info -->
      <!-- BEGIN: Register Form -->
      <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
        <div
            class="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
        >
          <h2
              class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
          >
            Sign Up
          </h2>
          <div
              class="intro-x mt-2 text-gray-500 dark:text-gray-500 xl:hidden text-center"
          >
            A few more clicks to sign in to your account.
          </div>
          <div class="intro-x mt-8">
            <input
                v-model="user.first_name"
                type="text"
                class="intro-x login__input w-full input input--lg border border-gray-300 block"
                placeholder="First Name"
            />
            <div v-if="user.first_name === null" class="text-theme-12 mt-2">
              This field is required
            </div>
            <!--              <div v-if="validation.first_name" class="text-theme-6 mt-2">This field is required</div>-->
            <input
                v-model="user.last_name"
                type="text"
                class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
                placeholder="Last Name"
            />
            <div v-if="user.last_name === null" class="text-theme-12 mt-2">
              This field is required
            </div>
            <!--              <div v-if="validation.last_name" class="text-theme-6 mt-2">This field is required</div>-->
            <input
                v-model="user.email"
                type="text"
                class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
                placeholder="Email"
            />
            <div v-if="user.email === null" class="text-theme-12 mt-2">
              This field is required
            </div>
            <!--              <div v-if="validation.email" class="text-theme-6 mt-2">This field is required</div>-->
            <input
                v-model="user.company"
                type="text"
                class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
                placeholder="Company name"
            />
            <input
                v-model="user.address"
                type="text"
                class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
                placeholder="Address"
            />
            <input
                v-model="user.password"
                type="password"
                class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
                placeholder="Password"
            />
            <div v-if="user.password === null" class="text-theme-12 mt-2">
              This field is required
            </div>
            <!--              <div v-if="validation.password" class="text-theme-6 mt-2">This field is required</div>-->
            <!--              <div class="intro-x w-full grid grid-cols-12 gap-4 h-1 mt-3">-->
            <!--                <div class="col-span-3 h-full rounded bg-theme-9"></div>-->
            <!--                <div class="col-span-3 h-full rounded bg-theme-9"></div>-->
            <!--                <div class="col-span-3 h-full rounded bg-theme-9"></div>-->
            <!--                <div-->
            <!--                  class="col-span-3 h-full rounded bg-gray-200 dark:bg-dark-2"-->
            <!--                ></div>-->
            <!--              </div>-->
            <!--              <a-->
            <!--                href=""-->
            <!--                class="intro-x text-gray-600 block mt-2 text-xs sm:text-sm"-->
            <!--                >What is a secure password?</a-->
            <!--              >-->
            <input
                v-model="confirm_password"
                type="password"
                class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
                placeholder="Password Confirmation"
            />
            <div v-if="confirm_password === null" class="text-theme-12 mt-2">
              This field is required
            </div>
            <!--              <div v-if="validation.confirm_password" class="text-theme-6 mt-2">This field is required</div>-->
          </div>
          <div
              class="intro-x flex items-center text-gray-700 dark:text-gray-600 mt-4 text-xs sm:text-sm"
          >
            <input
                v-model="agree"
                id="remember-me"
                type="checkbox"
                class="input border mr-2"
            />
            <label class="cursor-pointer select-none" for="remember-me"
            >I agree to the PMSTConverter</label
            >
            <a class="text-theme-1 dark:text-theme-10 ml-1" href="/terms"
            >Terms and Conditions</a
            >.
          </div>
          <div v-if="agree === false" class="text-theme-12 mt-2">
            This field is required
          </div>
          <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
            <button
                class="button button--lg w-full xl:w-32 text-white bg-theme-1 xl:mr-3 align-top"
                @click="handleSubmit"
            >
              Register
            </button>
            <button
                class="button button--lg w-full xl:w-32 text-gray-700 border border-gray-300 dark:border-dark-5 dark:text-gray-300 mt-3 xl:mt-0 align-top"
                @click="$router.push('login')"
            >
              Sign in
            </button>
          </div>
          <br />
          <div
              v-if="infoError === true"
              class="rounded-md flex items-center px-5 py-4 mb-2 bg-theme-6 text-white"
          >
            <AlertOctagonIcon class="w-6 h-6 mr-2" />
            Error in validation fields
          </div>
        </div>

      </div>
      <!-- END: Register Form -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AuthService from '../services/Auth';
const authService = new AuthService();

export default {
  data() {
    return {
      agree: false,
      infoError: false,
      confirm_password: null,
      validation: {
        email: false,
        first_name: false,
        last_name: false,
        password: false,
        confirm_password: false,
        agree: false,
      },
      user: {
        email: null,
        first_name: null,
        last_name: null,
        password: null,
        company: "",
        address: null
      },
      filter: {
        field: "name",
        type: "like",
        value: ""
      }
    };
  },
  mounted() {
    this.isLogedin();
  },
  methods: {
    validate() {
      let flag = true
      if (this.user.email === null) {
        this.validation.email = true
        flag = false
      }
      if (this.user.first_name === null) {
        this.validation.first_name = true
        flag = false
      }
      if (this.user.last_name === null) {
        this.validation.last_name = true
        flag = false
      }
      if (this.user.password === null) {
        this.validation.password = true
        flag = false
      }
      if (this.confirm_password === null) {
        this.validation.confirm_password = true
        flag = false
      }
      if (this.agree === null) {
        this.validation.agree = true;
        flag = false
      }

      return flag
    },
    isLogedin() {
      let jwt = authService.getToken();
      let user = authService.getUser();
      let refresh = authService.getRefresh();

      if (jwt && user && refresh) {
        this.$router.push("user-pdf");
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      let self = this
      let isValid = self.validate()
      let config = {
        headers: {
          Authorization: "false",
        }
      }
      if (self.user.password.length > 0 && isValid) {
        axios
          .post("user/create/", {
            email: self.user.email,
            password: self.user.password,
            first_name: self.user.first_name,
            last_name: self.user.last_name,
            company: self.user.company
          }, config)
          .then(response => {
            // console.log(response.data);
            if (response.data.message === "success") {
              axios
                .post("token/obtain/", {
                  email: self.user.email,
                  password: self.user.password
                })
                .then(response => {
                  let is_admin = response.data.user.is_superuser;
                  authService.setRefresh(response.data.refresh);
                  authService.setToken(response.data.access);
                  authService.setUser(response.data.user);
                  if (authService.getToken() != null) {
                    self.$emit("loggedIn");
                    if (self.$route.params.nextUrl != null) {
                      self.$router.push(self.$route.params.nextUrl);
                    } else {
                      if (is_admin === true) {
                        // this.$router.push("admin");
                        self.$router.push("/admin-aria");
                      } else {
                        self.$router.push("/user-pdf");
                      }
                    }
                  }
                })
                .catch(function(error) {
                  console.error(error.response);
                });
            } else {
              if (response.data.error === 1 && response.data.message === "mailuniq") {
                console.log(response.data)
                document.getElementById("show-modal").click()
              }
            }
          })
          .catch(function(error) {
            console.error(error.response);
            self.infoError = true
          });
      }
    }
  }
};
</script>
